const articles = {
  waiting: "ST_WAITING",
  disactive: "ST_DISACTIVE",
  received: "ST_RECEIVED",
  removed: "ST_REMOVED",
};

const packages = {
  empty: "ST_EMPTY",
  completing: "ST_COMPLETING",
  onTheWay: "ST_ON_THE_WAY",
  inWarehouse: "ST_IN_WAREHOUSE",
  completed: "ST_COMPLETED",
  finalized: "ST_FINALIZED",
  archived: "ST_ARCHIVED",
};

const weightType = {
  weight: "WEIGHT",
  volume: "VOLUME",
};

export { articles, packages, weightType };
